// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IonCol, IonGrid, IonRow } from "@ionic/react"
import { ConsoleSectionContainer } from "../../components"
import ConsoleSectionPage from "../ConsoleSectionPage"
import { Alert, useSession } from "../../../../lib"
import { useLocales } from "react-localized"
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons"


const WizardIndexPage: React.FC = () => {
  const {gettext} = useLocales()
  const session = useSession()
  return (
    <ConsoleSectionPage>
      <ConsoleSectionContainer
        ready={true}
        title={gettext("Setup assistant")}
      >
        <IonGrid>
          <IonRow className="w-512" style={{padding: "24px"}}>
            <IonCol
              onClick={() => {
                if (session.articlePath !== "intro/wizards") {
                  session.setArticlePath("intro/wizards")
                }
                if (session.articlePath === "intro/wizards") {
                  session.setArticlePath(null)
                }
              }}
              style={{cursor: "pointer"}}
            >
              <Alert heading={gettext("Get started")} icon={faCircleInfo}>
                <span>{gettext("Use a setup assistant to configure your account with a specific feature.")} </span>
                <span><a>{gettext("Read more")}</a></span>
              </Alert>
            </IonCol>
          </IonRow>
          <IonRow style={{borderBottom: "1px solid var(--color-nav-keyline)", paddingLeft: "24px"}}>
            <IonCol style={{padding: "12px 16px 12px 0px"}}>
              <h2 style={{marginBottom: "0px"}}>{gettext("Available assistants")}</h2>
            </IonCol>
          </IonRow>
        </IonGrid>
      </ConsoleSectionContainer>
    </ConsoleSectionPage>
  )
}


export { WizardIndexPage }